import { gql } from 'graphql-request';

import type { RequestDocument } from 'graphql-request';

export const COMPOSITION_CATEGORIES_AND_SUBCATEGORIES_QUERY: RequestDocument = gql`
  query CompositionCategoriesAndSubcategories {
    allGraphicCategories {
      id
      label
      order
      subcategories {
        id
        label
        order
        compositions {
          id
          label
          internalName
          aspectRatio
          source
          controls
          thumbnail {
            url
          }
        }
      }
    }
  }
`;

export default COMPOSITION_CATEGORIES_AND_SUBCATEGORIES_QUERY;
